import React, { ReactElement } from 'react'
import { queryClient } from '@borg/aemp-integrations'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

type PropsType = {
    children: ReactElement,
}

export const QueryClientWrapper: React.FC<PropsType> = ( { children } ) => {
	const shouldShowDevTools = window.location.hostname === 'localhost'

	return <QueryClientProvider client={queryClient}>
		{children}
		{ shouldShowDevTools &&
			<ReactQueryDevtools
				initialIsOpen={false}
				position="bottom-right"
			/>
		}
	</QueryClientProvider>
}
